import styled from 'styled-components';

import { grey5 } from 'approot/shared/styles/colours.style';
import { rem } from 'approot/shared/style';

export const MultipleChoiceTabs = styled.div`
  border-bottom: 1px solid ${grey5};
  height: ${rem(64)};
  flex-shrink: 0;
`;
